import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ totalFunding, totalAllocated, totalRemaining }) => {
  const data = {
    labels: [],
    datasets: [
      {
        label: "Funding Distribution",
        data: [totalAllocated, totalRemaining, totalFunding],
        backgroundColor: ["#FDBA74 ", "#F87171 ", "#86EFAC "], 
        borderColor: ["#FFFFFF", "#FFFFFF", "#FFFFFF"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className='flex items-center justify-center gap-x-4'>
      {/* Labels Section */}
      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-2'>
          <div className='w-4 h-4 bg-[#FDBA74] rounded-full'></div>

          <span>Total Allocated: ${totalAllocated?.toLocaleString()}</span>
        </div>
        <div className='flex items-center gap-2'>
          <div className='w-4 h-4 bg-[#F87171] rounded-full'></div>
          <span>Total Remaining: ${totalRemaining?.toLocaleString()}</span>
        </div>
        <div className='flex items-center gap-2'>
          <div className='w-4 h-4 bg-[#86EFAC] rounded-full'></div>

          <span>Total Funding: ${totalFunding?.toLocaleString()}</span>
        </div>
      </div>

    
      <div className="w-[200px]">
        <Pie data={data} />
      </div>
    </div>
  );
};

export default PieChart;
